export default {
    formId: 'editSucursalForm', //'createSucursalForm',
    formField: {
      e_sucursal_name: {
        name: 'e_sucursal_name',
        label: 'Nombre Sucursal*',
        requiredErrorMsg: 'La sucursal es requerida.'
      },
      e_sucursal_address: {
        name: 'e_sucursal_address',
        label: 'Direccion Sucursal*',
        requiredErrorMsg: 'La direccion sucursal es requerida.'
      },
      e_workplace: {
        name: 'e_workplace',
        label: 'Sitio de trabajo',
        requiredErrorMsg: 'El sitio de trabajo es requerido.',
      },
      e_family_fund_compensation: {
        name: 'e_family_fund_compensation',
        label: 'Caja de compensacion',
        requiredErrorMsg: 'El Caja de compensacion es requerido.',
      },
      e_landline: {
        name: 'e_landline',
        label: 'Telefono fijo'
      },
      e_cell_phone: {
        name: 'e_cell_phone',
        label: 'Celular',
        requiredErrorMsg: 'El celular es requerido.'
      },
      e_country: {
        name: 'e_country',
        label: 'Pais',
        requiredErrorMsg: 'El pais es requerido.',
      },
      e_departament: {
        name: 'e_departament',
        label: 'Departamento',
        requiredErrorMsg: 'El departamento es requerido.'
      },
      e_municipaly: {
        name: 'e_municipaly',
        label: 'Municipio',
        requiredErrorMsg: 'El municipio es requerido.',
        // invalidErrorMsg: 'Card number is not valid (e.g. 4111111111111)'
      },
      e_arl: {
        name: 'e_arl',
        label: 'ARL Vinculada a la empresa',
        requiredErrorMsg: 'ARL Vinculada a la empresa es requerida.'
      },
      e_associated_bank: { 
        name: 'e_associated_bank',
        label: 'Banco asociado',
        requiredErrorMsg: 'Banco asociado es requerido.'
      },
      e_type_account_bank: {
        name: 'e_type_account_bank',
        label: 'Tipo de cuenta',
        requiredErrorMsg: 'Tipo de cuenta es requerida.'
      },
      e_account_number: {
        name: 'e_account_number',
        label: 'Numero de cuenta',
        requiredErrorMsg: 'Numero de cuenta es requerido.'
      },
      e_logo_sucursal: {
        name: 'e_logo_sucursal',
        label: 'Logo sucursal',
        requiredErrorMsg: 'Logo sucursal es requerido.'
      }, 
      e_logo_sucursal_namd_saved_file: {
        name: 'e_logo_sucursal_namd_saved_file',
        label: 'Logo sucursal',
        requiredErrorMsg: 'Logo sucursal es requerido.'
      }
    }
  };
  